import { render, staticRenderFns } from "./LegacyContentListModule.vue?vue&type=template&id=8646b510"
import script from "./LegacyContentListModule.vue?vue&type=script&lang=js"
export * from "./LegacyContentListModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports